// For full API documentation, including code examples, visit https://wix.to/94BuAAs
import wixWindow from 'wix-window';
import {memory} from 'wix-storage';
// ...
memory.setItem("HoverColor", "#858585");

$w.onReady(function () {
	if(wixWindow.formFactor === "Mobile"){
  	$w("#image49").show();
	}


});